'use client';

import { HelpOutline as HelpIcon } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { ReactNode } from 'react';
export const FormField = ({
  label,
  htmlFor,
  description,
  endAdornment,
  children
}) => {
  return <div className="flex flex-col gap-1">
            <div className="flex justify-between items-center gap-2">
                <div className="flex items-center gap-1 min-w-0">
                    <label htmlFor={htmlFor} className="block text-sm leading-5 font-medium text-foreground truncate">
                        {label}
                    </label>
                    {description && <Tooltip title={description} placement="top" arrow>
                            <Box component="span" className="inline-flex items-center cursor-help shrink-0" aria-label={description}>
                                <HelpIcon sx={{
              fontSize: '0.875rem',
              color: 'var(--foreground-muted, #9ca3af)'
            }} />
                            </Box>
                        </Tooltip>}
                </div>
                {endAdornment ? <div className="shrink-0">{endAdornment}</div> : null}
            </div>
            {children}
        </div>;
};